/**
 * Class 2 plugin host — isolated iframe on distinct origin (Spike 4).
 */

const React = (globalThis as { React?: typeof import('react') }).React!;

interface Class2PluginFrameProps {
  pluginId: string;
  sandboxUrl: string;
  title?: string;
}

export function Class2PluginFrame({ pluginId, sandboxUrl, title }: Class2PluginFrameProps) {
  return (
    <iframe
      data-plugin-class2={pluginId}
      data-testid={`class2-plugin-frame-${pluginId}`}
      title={title || pluginId}
      src={sandboxUrl}
      sandbox="allow-scripts"
      style={{
        width: '100%',
        minHeight: '480px',
        border: '1px solid var(--border-color, #334155)',
        borderRadius: '8px',
        background: 'var(--card-bg, #0f172a)',
      }}
    />
  );
}
